export const isSingleBooking = (): boolean => {
    return document.location.pathname === "/booking/";
};
